<template>
  <Form @submit="onSubmit">
    <div class="container spa-summary">
      <div class="row mt-5 justify-content-center">
        <div class="col-xxl-11 col-xl-13">
          <div class="bg-white h-100 py-md-5 pt-4 pb-3 px-md-5 px-4">
            <h2>Your Spa Day booking summary</h2>

            <div class="spa-summary-group">
              <button class="spa-edit" v-on:click="onEditDate()">Edit</button>

              <label> Date &amp; Guests </label>
              <div class="row mb-2">
                <div class="col-sm-5 col-7">Date</div>
                <div class="col-sm-19 col-17 pe-sm-3 pe-1">
                  {{ formatDate(search.date) }}
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-sm-5 col-7">Guests</div>
                <div class="col-sm-19 col-17 pe-sm-3 pe-1">
                  {{ search.guestCount }}
                </div>
              </div>

              <div class="row">
                <div class="col-sm-5 col-7">Spa Package</div>
                <div class="col-sm-19 col-17 pe-sm-3 pe-1">
                  {{ search.spaDay.DisplayName }}
                </div>
              </div>
            </div>

            <div
              class="spa-summary-group"
              v-if="hasTreatments"
              v-for="(guest, index) in search.guests"
            >
              <button class="spa-edit" v-on:click="onEditTreatments()">
                Edit
              </button>

              <label> {{ guest.firstName }}'s Treatments </label>
              <div class="row mb-3">
                <div class="col-24 col-lg-5">Treatments</div>
                <div class="col-24 col-lg-19">
                  <ul class="treatments-list">
                    <li v-for="(t, index) in guest.treatments">
                      <div class="row">
                        <div class="col-18">
                          {{ t.treatment.DisplayName }}
                          {{ t.duration.Duration }}minutes
                        </div>
                        <div class="col-6" v-if="!t.duration.IsIncluded">
                          <strong>
                            +&pound;{{ t.duration.PriceDifference }}
                          </strong>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div v-if="hasAddOns">
              <hr />
              <h2>Add Ons</h2>

              <div
                class="spa-summary-group"
                v-if="search.selectedTreatmentExtras"
              >
                <label> Extra Treatments </label>
                <div
                  class="row mb-3"
                  v-for="(item, i) in search.selectedTreatmentExtras"
                >
                  <div class="col-24">
                    <div class="summary-add-on p-3 position-relative">
                      <button class="spa-edit mt-3" v-on:click="onEditAddOns()">
                        Edit
                      </button>

                      <div class="row">
                        <div class="col-24">
                          <div class="row">
                            <div class="col-20">
                              <label class="small">
                                {{ item.selection.treatment.DisplayName }} for
                                {{ guestNameForItem(item) }}
                              </label>
                            </div>
                            <div class="col">
                              <strong class="mr-5"
                                >&pound;{{
                                  item.selection.duration.Price
                                }}</strong
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-24">
                          <div
                            v-html="item.selection.treatment.Description"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="spa-summary-group"
                v-for="(addOn, index) in search.groupAddOns"
              >
                <label>
                  {{ addOn.content.DisplayName }}
                </label>
                <div class="row mb-3">
                  <div class="col-24">
                    <div class="summary-add-on p-3 position-relative">
                      <button class="spa-edit mt-3" v-on:click="onEditAddOns()">
                        Edit
                      </button>

                      <div class="row">
                        <div class="col-24">
                          <div class="row">
                            <div class="col-20">
                              <label class="small">
                                {{ search.guests.length }}
                                {{
                                  search.guests.length == 1 ? "pass" : "passes"
                                }}
                                :
                                {{ formatTime(addOn.selection.StartDateTime) }}
                                entry
                              </label>
                            </div>
                            <div class="col">
                              <strong class="mr-5"
                                >&pound;{{
                                  search.guests.length *
                                  addOn.selection.ActualPrice
                                }}</strong
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-24">
                          <div v-html="addOn.content.Description"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="spa-summary-group"
                v-if="search.selectedGardenExtras != null"
              >
                <label>
                  {{ search.selectedGardenExtras.addOn.content.DisplayName }}
                </label>
                <div class="row mb-3">
                  <div class="col-24">
                    <div class="summary-add-on p-3 position-relative">
                      <button class="spa-edit mt-3" v-on:click="onEditAddOns()">
                        Edit
                      </button>

                      <div class="row">
                        <div class="col-24">
                          <div class="row">
                            <div class="col-20">
                              <label class="small">
                                {{
                                  search.selectedGardenExtras.guestIndexes
                                    .length
                                }}
                                passes :
                                {{
                                  formatTime(
                                    search.selectedGardenExtras.selection
                                      .StartDateTime
                                  )
                                }}
                                entry
                              </label>
                            </div>
                            <div class="col">
                              <strong class="mr-5"
                                >&pound;{{
                                  search.guests.length *
                                  search.selectedGardenExtras.selection
                                    .ActualPrice
                                }}</strong
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-24">
                          <div
                            v-html="
                              search.selectedGardenExtras.addOn.content
                                .Description
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="spa-summary-group"
                v-if="search.selectedMudExtras != null"
              >
                <label>
                  {{ search.selectedMudExtras.addOn.content.DisplayName }}
                </label>
                <div class="row mb-3">
                  <div class="col-24">
                    <div class="summary-add-on p-3 position-relative">
                      <button class="spa-edit mt-3" v-on:click="onEditAddOns()">
                        Edit
                      </button>

                      <div class="row">
                        <div class="col-24">
                          <div class="row">
                            <div class="col-20">
                              <label class="small">
                                {{
                                  search.selectedMudExtras.guestIndexes.length
                                }}
                                passes :
                                {{
                                  formatTime(
                                    search.selectedMudExtras.selection
                                      .StartDateTime
                                  )
                                }}
                                entry
                              </label>
                            </div>
                            <div class="col">
                              <strong class="mr-5"
                                >&pound;{{
                                  search.selectedMudExtras.selection.ActualPrice
                                }}</strong
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-24">
                          <div
                            v-html="
                              search.selectedMudExtras.addOn.content.Description
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <hr />
              <h2>Your Bill</h2>
            </div>
            <div class="spa-summary-group">
              <div class="row bill">
                <div class="col-md-17 col-15">
                  <div class="row mb-2">
                    <div class="col-24 col-xl-7">Spa Days:</div>
                    <div class="col-24 col-xl-17">
                      {{ search.guests.length }} x &pound;{{
                        search.spaDay.bookingDetails.ActualPrice
                      }}
                      =
                      <strong
                        >&pound;{{
                          search.guests.length *
                          search.spaDay.bookingDetails.ActualPrice
                        }}</strong
                      >
                    </div>
                  </div>

                  <div class="row" v-if="hasExtras">
                    <div class="col-24 col-xl-7">Extras:</div>
                    <div class="col-24 col-xl-17">&pound;{{ extrasTotal }}</div>
                  </div>
                  <div class="row" v-if="hasAddOns">
                    <div class="col-24 col-xl-7">Add Ons:</div>
                    <div class="col-24 col-xl-17">
                      &pound;{{ addOnsTotal() }}
                    </div>
                  </div>
                </div>
                <div class="col-md-7 col-9 bordered">
                  <span class="spa-total"
                    >Total:
                    <span class="spa-total-amount"
                      >&pound;{{ total() }}</span
                    ></span
                  >
                </div>
              </div>
            </div>

            <div>
              <spa-itinerary
                v-bind:isSpaDay="true"
                v-bind:title="'Your Spa Day Itinerary'"
              ></spa-itinerary>
            </div>
          </div>
        </div>
      </div>
    </div>

    <actions-bar>
      <template v-slot:actions>
        <div class="row">
          <div class="col-12">
            <button
              v-on:click="onBack"
              type="button"
              class="btn btn--transparent btn--back"
            >
              Back
            </button>
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button class="btn btn--slate-blue btn--continue" type="submit">
              Payment
            </button>
          </div>
        </div>
      </template>
    </actions-bar>
  </Form>
</template>

<script>
import ActionsBar from "@/shared/components/ActionsBar.vue";
import { Form } from "vee-validate";

import SpaItinerary from "../components/SpaItinerary.vue";
import { store } from "../store/index";

export default {
  name: "SpaTreatmentSummary",

  components: {
    ActionsBar,
    Form,
    SpaItinerary,
  },
  computed: {
    hasTreatments() {
      return this.search.guests.filter(
        (g) => g.treatments != null && g.treatments.length
      ).length;
    },
    hasExtras() {
      return store.getters.extras.length;
    },
    extrasTotal() {
      return store.getters.extrasTotal;
    },
    hasAddOns() {
      return (
        (this.search.groupAddOns != null && this.search.groupAddOns.length) ||
        this.search.selectedMudExtras != null ||
        this.search.selectedGardenExtras != null
      );
    },
    session() {
      return store.getters.session;
    },
    search() {
      return store.getters.search;
    },
    booking() {
      return store.getters.booking;
    },
  },
  methods: {
    onSubmit: function () {
      this.$router.push({
        name: "spa_day_payment",
        params: { id: this.session.Id },
      });

      ////let payload = {
      ////    id : this.session.Id,
      ////    payload : null
      ////}

      ////store.dispatch("confirmBooking", payload).then(() => {

      ////})
    },

    onEditDate() {
      this.$router.push({
        name: "spa_day_search",
        params: { id: this.session.Id },
      });
    },
    onEditTreatments() {
      this.$router.push({
        name: "spa_day_treatments",
        params: { id: this.session.Id },
      });
    },
    onEditAddOns() {
      this.$router.push({
        name: "spa_day_add_ons",
        params: { id: this.session.Id },
      });
    },
    formatTime(dateTime) {
      let date = moment(dateTime);
      return date.format("HH:mm");
    },
    formatDate(input) {
      let date = moment(input);
      return date.format("ddd Do MMMM YYYY");
    },
    addOnsTotal() {
      return store.getters.addOnsTotal;
    },
    treatmentsTotal() {
      return store.getters.treatmentsTotal;
    },
    total() {
      return store.getters.dayTotal;
    },
    guestNameForItem(item) {
      return this.search.guests[item.guestIndex].firstName;
    },
  },
};
</script>

<style>
.treatments-list,
.treatments-list li {
  list-style: none;
  padding: 0;
  font-size: 16px;
}

.booking .spa-summary h1,
.booking .spa-summary h2 {
  font-size: 24px;
  margin-bottom: 30px;
  text-transform: none;
}

.spa-summary-group {
  margin-bottom: 40px;
  position: relative;
}

.spa-summary-group label {
  font-weight: bold;
  font-size: 14px !important;
  margin-bottom: 10px;
}

.spa-edit {
  border: none;
  background-color: transparent;
  position: absolute;
  right: 0%;
  top: 0%;
  height: 15px;
  text-indent: -9999px;
  width: 15px;
  background-position: center center;
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-image: url("@/assets/img/booking/edit.svg");
}

label.small {
  font-size: 12px;
}

.summary-add-on {
  border: solid 1px #aaa;
}

.summary-add-on .spa-edit {
  right: 15px;
}

.summary-add-on p {
  width: 85%;
}

.bordered {
  border-left: solid 1px #aaa;
}

.bill {
  min-height: 75px;
}

.spa-total {
  font-size: 24px;
}

.spa-total-amount {
  font-weight: bold;
}

@media (max-width: 767px) {
  .spa-summary-group {
    margin-bottom: 25px;
  }
}
</style>
